var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNews = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M3 36V4h34v32H3Zm3.4-3.556h27.2V7.556H6.4v24.888Zm3.4-3.555h20.4v-3.556H9.8v3.556Zm0-7.111h6.8V11.11H9.8v10.667Zm10.2 0h10.2v-3.556H20v3.556Zm0-7.111h10.2V11.11H20v3.556Z"
})));
export default SvgNews;